export default __webpack_public_path__ + "static/media/achievement.624cc86a.svg";